import { render, staticRenderFns } from "./parameter-group.vue?vue&type=template&id=9c239074&"
import script from "./parameter-group.component.ts?vue&type=script&lang=ts&"
export * from "./parameter-group.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports